import React, {Component} from 'react'
import { connect } from 'react-redux';

import CommentListHeader from '../../components/comments/comment/CommentListHeader'
import CommentList from '../../components/comments/comment/CommentList'
import Pagination from '../../components/common/Pagination';
import ListTitle from "../../components/common/list/ListTitle";
import { parseListParams } from '../../components/common/CommentListHelper';
import CommentPopupLayer from "./CommentPopupLayer";

@connect(state => ({
    items: state.comment.item.items,
    totalCount: state.comment.item.totalCount,
    searchKeyword: state.comment.condition.searchKeyword,
}))
class CommentApp extends Component {

	render() {

        const { totalCount, searchKeyword } = this.props;

        return (
				<div className="inner_article reply_article">
					<h2 id="kakaoBody" className="screen_out">티스토리 관리센터 본문</h2>
					<ListTitle headTitle="댓글 관리" totalCount={totalCount} searchKeyword={searchKeyword}/>
					<CommentListHeader />
					<CommentList />
					<Pagination totalCount={totalCount} parseListParams={parseListParams}/>
					<CommentPopupLayer />
				</div>
		)
	}
}

export default CommentApp;
